import { Link } from "react-router-dom";
import {
  FaceSmileIcon,
  CameraIcon,
  LinkIcon,
} from "@heroicons/react/24/outline"; // or use `/solid`

import { Facebook, Instagram, Linkedin } from "lucide-react";

const socialIcons = [
  {
    id: 1,
    link: "https://facebook.com/",
    label: "Facebook",
    icon: <Facebook className="w-5 h-5" />,
  },
  {
    id: 2,
    link: "https://www.instagram.com/",
    label: "Instagram",
    icon: <Instagram className="w-5 h-5" />,
  },
  {
    id: 3,
    link: "https://linkedin.com/",
    label: "LinkedIn",
    icon: <Linkedin className="w-5 h-5" />,
  },
];

const industryLinks = [
  { title: "Beauty", href: "/industry/beauty" },
  { title: "Nails", href: "/industry/nails" },
  { title: "Barbers", href: "/industry/barbers" },
  { title: "Spa & Sauna", href: "/industry/spa" },
  { title: "Massages", href: "/industry/massages" },
  { title: "Tattoo", href: "/register" },
  { title: "Restaurants", href: "/industry/restaurants" },
  { title: "Take away", href: "/industry/takeaway" },
  { title: "Night Market", href: "/industry/night-market" },
  { title: "Gym", href: "/register" },
  { title: "Pet care", href: "/register" },
  { title: "Car wash", href: "/register" },
];

const footerSections = [
  {
    title: "For Business",
    links: [
      { title: "Home", href: "/" },
      { title: "About", href: "/about" },
      { title: "Price", href: "/price" },
      { title: "Contact", href: "/contact" },

      { title: "For Users", href: "https://lokalai.com/" },
    ],
  },
  {
    title: "For your Industry",
    links: industryLinks,
  },
  {
    title: "About",
    links: [
      { title: "Career", href: "/" },
      { title: "Help Center", href: "/help-center" },
      { title: "Blog", href: "/about" },
      { title: "Sitemap", href: "/contact" },
    ],
  },

  {
    title: "Legal",
    links: [
      { title: "Privacy Policy", href: "/service-details" },
      { title: "Terms of service", href: "/service-details" },
      { title: "Terms of use", href: "/service-details" },
    ],
  },
];

const FooterIntro = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white px-6 pt-16 pb-8">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between gap-12">
        {/* Left: Logo & Description */}
        <div className="lg:w-1/3">
          <Link to="/">
            <img
              src="/logo/logo_center.png"
              alt="Lokalai Logo"
              className="w-44 mb-6"
            />
          </Link>
          <p className="text-sm text-text mb-6">
            Leveraging Artificial Intelligence for your Business.
          </p>
          <ul className="flex gap-3">
            {socialIcons.map((item) => (
              <li key={item.id}>
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-textGray flex items-center justify-center text-textGray hover:bg-redlight hover:text-white transition-all rounded"
                  aria-label={item.label}
                >
                  {item.icon}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Center: Links */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {footerSections.map((section, idx) => (
            <div key={idx}>
              <h4 className="font-semibold mb-4">{section.title}</h4>
              <ul className="space-y-2 text-sm text-textGray">
                {section.links.map((link, i) => (
                  <li key={i}>
                    <a
                      href={link.href}
                      className="hover:text-redlight transition-colors"
                    >
                      {link.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom */}
      <div className="mt-12 border-t border-gray-800 pt-6 text-center text-xs text-gray-500">
        © {currentYear} Lokalai ltd.
      </div>
    </footer>
  );
};

export default FooterIntro;
